import { Dispatch } from "react";
import {
  ADD_SALES_ITEM_ERROR,
  ADD_SALES_ITEM_LOAD,
  ADD_SALES_ITEM_SUCCESS,
  GET_SALES_ITEMS_LOAD,
  GET_SALES_ITEMS_SUCCESS,
  GET_SALES_ITEMS_ERROR,
} from "../types";

export const addSalesItems = (list: any[]) => async (dispatch: any) => {
  try {
    dispatch({
      type: ADD_SALES_ITEM_LOAD,
    });

    dispatch({
      type: ADD_SALES_ITEM_SUCCESS,
      payload: list,
    });

    localStorage.setItem("salesItems", JSON.stringify(list));
  } catch (error) {
    dispatch({
      type: ADD_SALES_ITEM_ERROR,
      payload: error,
    });
  }
};

export const getSalesItems = () => async (dispatch: any) => {
  try {
    dispatch({
      type: GET_SALES_ITEMS_LOAD,
    });

    const list = localStorage.getItem("salesItems");

    if (list) {
      dispatch({
        type: GET_SALES_ITEMS_SUCCESS,
        payload: JSON.parse(list),
      });
    }
  } catch (error) {
    dispatch({
      type: GET_SALES_ITEMS_ERROR,
      payload: error,
    });
  }
};
